import React from 'react';
import { Link } from 'react-router-dom';

const auditPoints = [
  'Where you\'re losing leads',
  'What to fix on your website',
  'How AI can automate your workflow',
];

const arrowIcon = (
  <svg width="13" height="13" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 12L12 2M12 2H5M12 2v7" />
  </svg>
);

export default function CTASection() {
  return (
    <section className="py-32 px-6 w-full" style={{ background: '#082318' }}>
      {/* Offer card */}
      <div
        className="max-w-[1100px] mx-auto rounded-3xl p-12 md:p-16 text-center relative overflow-hidden mb-16"
        style={{ background: 'linear-gradient(135deg, #0c2e1e 0%, #0e3322 100%)', border: '1px solid rgba(212,245,66,0.15)' }}
      >
        {/* Glow */}
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-48 pointer-events-none"
          style={{ background: 'radial-gradient(ellipse, rgba(212,245,66,0.08) 0%, transparent 70%)' }}
        />

        <p className="text-xs font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>Free Offer</p>
        <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-3 leading-tight">
          Free Website + AI Audit
        </h2>
        <p className="text-xl md:text-2xl font-semibold mb-8" style={{ color: 'rgba(255,255,255,0.45)' }}>
          (2-Min Video)
        </p>

        <p className="text-base mb-5" style={{ color: 'rgba(255,255,255,0.55)' }}>We'll show you exactly:</p>

        <ul className="flex flex-col items-center gap-3 mb-10">
          {auditPoints.map((pt, i) => (
            <li key={i} className="flex items-center gap-3 text-base font-medium" style={{ color: 'rgba(255,255,255,0.8)' }}>
              <span
                className="flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold flex-shrink-0"
                style={{ background: 'rgba(212,245,66,0.15)', color: '#d4f542' }}
              >✓</span>
              {pt}
            </li>
          ))}
        </ul>

        <div
          className="inline-block px-8 py-4 rounded-2xl mb-10"
          style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}
        >
          <p className="text-sm font-medium italic" style={{ color: 'rgba(255,255,255,0.5)' }}>
            Not just a website. Not just automation.<br />
            A system that brings clients and handles them for you.
          </p>
        </div>

        <div className="mb-8">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2.5 px-10 py-4 rounded-xl text-sm font-bold transition duration-200"
            style={{ background: '#d4f542', color: '#082318' }}
            onMouseEnter={e => e.currentTarget.style.background = '#c8e830'}
            onMouseLeave={e => e.currentTarget.style.background = '#d4f542'}
          >
            Get My Free Audit
            {arrowIcon}
          </Link>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
          <p className="text-xs font-mono uppercase tracking-widest" style={{ color: 'rgba(255,255,255,0.3)' }}>
            ⚠ Limited clients per month
          </p>
          <span className="hidden sm:block w-1 h-1 rounded-full" style={{ background: 'rgba(255,255,255,0.2)' }} />
          <p className="text-xs font-mono uppercase tracking-widest" style={{ color: 'rgba(255,255,255,0.3)' }}>
            We only work with serious businesses
          </p>
        </div>
      </div>

      {/* Final CTA strip */}
      <div className="max-w-[1100px] mx-auto text-center">
        <p className="text-lg md:text-xl font-semibold mb-8" style={{ color: 'rgba(255,255,255,0.6)' }}>
          Stop missing leads. Stop wasting time.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center gap-2.5 px-10 py-4 rounded-xl text-sm font-bold transition duration-200"
          style={{ background: '#d4f542', color: '#082318' }}
          onMouseEnter={e => e.currentTarget.style.background = '#c8e830'}
          onMouseLeave={e => e.currentTarget.style.background = '#d4f542'}
        >
          Get Your Free Audit Now
          {arrowIcon}
        </Link>
      </div>
    </section>
  );
}

